"use client";
import { Button, PasswordInput, TextInput } from "@mantine/core";
import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import { useState } from "react";
import { Lock, Message } from "react-iconly";

const LoginForm = ({ className }: { className: string }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const searchParams = useSearchParams();

  // Get error from URL if present
  const urlError = searchParams?.get("error");

  const getErrorMessage = (errorCode: string | null): string => {
    if (!errorCode) return "";

    switch (errorCode) {
      case "AccessDenied":
        return "Access denied. You don't have permission to access this resource.";
      case "InvalidCredentials":
        return "Invalid email or password. Please try again.";
      case "CredentialsSignin":
        return "Login failed. Please check your credentials and try again.";
      default:
        return "An error occurred during login. Please try again.";
    }
  };

  useState(() => {
    if (urlError) {
      setError(getErrorMessage(urlError));
    }
  });

  const onFormSubmit = async (event: any) => {
    event.preventDefault();
    try {
      setLoading(true);
      setError(null);

      const formData = new FormData(event.target);
      const email = formData?.get("email");
      const password = formData?.get("password");

      const result = await signIn("credentials", {
        email,
        password,
      });

      if (result?.error) {
        setError(getErrorMessage(result.error));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setError("An unexpected error occurred. Please try again later.");
      console.log({ error });
    }
  };
  return (
    <form className={className} onSubmit={onFormSubmit}>
      <TextInput leftSection={<Message />} disabled={loading} required name="email" type="email" placeholder="Email" className="gr-login-form-input" />

      <PasswordInput leftSection={<Lock />} height={50} disabled={loading} required name="password" type="password" placeholder="Password" className="gr-login-form-input" />

      {error && (
        <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
          <ul className="list-disc pl-5 text-red-600 text-sm">
            <li>{error}</li>
          </ul>
        </div>
      )}

      <Button disabled={loading} type="submit" className="min-w-full lg:min-w-[300px] min-h-[48px] border rounded-lg px-3 outline-none bg-gr-primary-300 text-white font-[600] tracking-tight text-[18px] mt-[5px]" loading={loading}>
        Login
      </Button>
    </form>
  );
};

export default LoginForm;
